import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {getAllPosts, filterPost} from '../redux/actions/postsActions';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import MyButton from '../util/MyButton';
import Common from '../components/Common';
import PostLists from '../components/Manager/Posts/PostLists';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
  ...theme,
  container: {
    padding: 0,
    marginTop: theme.spacing.unit * 2,
  },
  itemWrapper: {
    position: 'relative',
    borderBottom: '1px solid #d7d7d7',
    '&:last-child': {
      borderBottom: 0,
    },
    '& p:last-child': {
      marginBottom: 0,
    }
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
    '& tr': {
        position: 'relative',
    },
    '& th': {
        padding: '8px 15px',
        minWidth: 55,
    },
    '& td': {
        padding: '8px 15px',
        minWidth: 55,
    },
    '& tbody tr:hover': {
        backgroundColor: '#f7f7f7',
    },
    '& tbody tr:hover td:last-child': {
        opacity: 1,
    },
    '& thead tr th:last-child, & tbody td:last-child': {
        minWidth: 'auto',
        width: 'auto',
        position: 'absolute',
        backgroundColor: '#f7f7f7',
        padding: '8px 5px',
    },
    '& tbody td:last-child' : {
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        borderBottom: 0,
        opacity: 0,
    },
    '& tbody td:first-child': {
        backgroundColor: 'transparent',
    },
    '& th:first-child': {
        minWidth: 30,
    },
    '& td:first-child': {
        minWidth: 30,
    },
    '& td.loading': {
        textAlign: 'center',
        opacity: '1!important',
        position: 'relative!important',
        color: 'orange',
        fontSize: 18,
    },
    '& td.loading span': {
        fontSize: 14,
        verticalAlign: 'middle',
    }
  },
  button: {
    margin: theme.spacing.unit,
  },
  marginTop: {
      marginTop: 20,
  },
  listBox: {
      padding: '5px 15px',
  },
  titleBox: {
    textTransform: 'uppercase',
    fontWeight: 500,
    marginTop: 10,
    marginBottom: 0,
    color: '#d7d7d7',
  },
  moreAction: {
    padding: 8,
    color: '#d7d7d7',
  },
  btnAction: {
    backgroundColor: '#ffc175',
    borderRadius: 4,
    padding: '15px 20px',
    margin: '10px auto 20px',
    display: 'block',
    textAlign: 'center',
    color: '#673100',
    fontWeight: 500,
    fontSize: 16,
  },
  marginGrid: {
    outline: '1px solid #d7d7d7',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#222',
    '&:hover': {
      backgroundColor: '#333',
    },
    width: '100%',
    maxWidth: 960,
    margin: '15px auto 0',
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  textWhite: {
    '& span': {
      color: '#d7d7d7',
    }
  }
})

class Posts extends Component {
    constructor(props) {
      super(props);
      this.state = {
          page: 0,
          rowsPerPage: 10,
          filterTitle: '',
          filterStatus: '-1',
          isFilter: false,
      }
  }

  handleChangePage = (event, page) => {
      this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
      this.setState({ page: 0, rowsPerPage: event.target.value });
  };

  componentDidMount() {
    const list_post = this.props.posts.posts;
    if(list_post.length === 0) {
        this.props.getAllPosts();
    }
  }

  handleChange = name => event => {
    var filter = {
        title : name === 'filterTitle' ? event.target.value : this.state.filterTitle,
        status : name === 'filterStatus' ? event.target.value : this.state.filterStatus,
    };
    this.props.filterPost(filter)
    this.setState({ [name]: event.target.value });
  };

  render() {
    var {posts} = this.props;
    const { rowsPerPage, page, isFilter, filterStatus } = this.state;
    const { classes, loading } = this.props;
    var list_post = posts.posts;
    list_post = list_post.filter((post) => {
        return post.domain === 'ntea.vn';
    });
    if(posts.title) {
        list_post = list_post.filter((post) => {
            return post.title.vi.toLowerCase().indexOf(posts.title.toLowerCase()) !== -1
        });
    }
    if(posts.status) {
        list_post = list_post.filter((post) => {
              if(posts.status === '-1') {
                  return post;
              } else {
                  return post.status === parseInt(posts.status);   
              }
          })
      }
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, list_post.length - page * rowsPerPage);

    let recentPostMarkup = !loading ? (
        list_post.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((post, index) => 
            <PostLists key={index} index={index+1} post={post} />
        )
  ) : ( 
    <tr>
      <td colSpan="12" className="alignCenter"><i className="fas fa-spinner fa-pulse fa-2x textWarning" /></td>
    </tr>
  );
    return (
      <Fragment>
            <Common isPosts={true} openFilter={() => this.setState({isFilter: !isFilter})} />
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Tìm bài viết"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                onChange={this.handleChange('filterTitle')}
              />
            </div>
            <div className={classes.container}>
            <Grid item container>
                {isFilter &&
                <Grid item sm={2} className={classes.marginGrid}>
                    <div className={classes.itemWrapper}>
                        <div className={classes.listBox}>
                            <Typography className={classes.titleBox} variant="body1" gutterBottom>
                            Trạng thái
                            </Typography>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={filterStatus === '-1' ? true : false}
                                        onChange={this.handleChange('filterStatus')}
                                        value='-1'
                                        color="primary"
                                    />
                                    }
                                    label="Tất cả"
                                    className={classes.textWhite}
                                />
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={(filterStatus === '1' || filterStatus === '-1') ? true : false}
                                        onChange={this.handleChange('filterStatus')}
                                        value='1'
                                        color="primary"
                                    />
                                    }
                                    label="Công bố"
                                    className={classes.textWhite}
                                />
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={(filterStatus === '0' || filterStatus === '-1') ? true : false}
                                        onChange={this.handleChange('filterStatus')}
                                        value='0'
                                        color="primary"
                                    />
                                    }
                                    label="Riêng tư"
                                    className={classes.textWhite}
                                />
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={(filterStatus === '2' || filterStatus === '-1') ? true : false}
                                        onChange={this.handleChange('filterStatus')}
                                        value='2'
                                        color="primary"
                                    />
                                    }
                                    label="Mật khẩu"
                                    className={classes.textWhite}
                                />
                            </FormGroup>
                        </div>
                    </div>
                </Grid>
                }
                <Grid item sm={isFilter ? 10 : 12} className={classes.marginGrid}>
                <div className={classes.itemWrapper}>
                    <div className="table">
                        <table>
                            <thead>
                                <tr style={{borderTop: 0}}>
                                    <td>STT</td>
                                    <td>Tiêu đề</td>
                                    <td>Mô tả</td>
                                    <td>Đường dẫn</td>
                                    <td>Chuyên mục</td>
                                    <td>Trạng thái</td>
                                    <td>Xuất bản</td>
                                    <td>Tác giả</td>
                                    <td><i className="fal fa-eye" /></td>
                                    <td>
                                        <MyButton 
                                            tip="Quản lý cột" 
                                            // onClick={this.handleClose} 
                                            tipClassName={classes.moreAction}
                                        >
                                            <SettingsApplicationsIcon />
                                        </MyButton>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {recentPostMarkup}
                                {emptyRows > 0 && (
                                    <tr style={{ height: 48 * emptyRows }}>
                                    <td colSpan={12} />
                                    </tr>
                                )}
                            </tbody>
                            </table>
                        </div>
                    </div>
                </Grid>
            </Grid>
            </div>
      </Fragment>
    )
  }
}

Posts.propTypes = {
    getAllPosts: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    posts: state.posts,
    loading: state.UI.loading,
})

export default connect(mapStateToProps, { getAllPosts, filterPost })(withStyles(styles)(Posts));